import React from "react";
import {
    Box,
    Grid,
    Button,
    TextField,
    Typography,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
} from "@mui/material";
import {withStyles} from "@mui/styles";
import {dialogTitleStyles} from "../../constants/styles";

class DialogItemForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            item: null,
            isOpen: false,
            onSubmit: null,
        };
    }

    open = ({item, onSubmit}) => {
        this.setState({
            item: item || {
                code: "",
                meaning: "",
                year_from: "",
                year_to: "",
            },
            isOpen: true,
            onSubmit,
        });
    }

    close = () => {
        this.setState({
            item: null,
            isOpen: false,
            onSubmit: null,
        });
    }

    submitItem = () => {
        this.state.onSubmit(this.state.item);
    }

    changeItem = ({target}) => {
        const {name, value} = target;
        let item = {...this.state.item};
        item[name] = value;
        this.setState({item});
    }

    render() {
        const {item, isOpen} = this.state;
        const {classes} = this.props;

        if (!isOpen) return null;

        const isEdit = Boolean(item?.id);

        return (
            <Dialog
                fullWidth
                open={isOpen}
                maxWidth="sm"
                onClose={this.close}
            >
                <DialogTitle className={classes.dialogTitle}>
                    <Typography variant="h3">
                        {isEdit ? "Редактирование элемента" : "Создание элемента"}
                    </Typography>
                </DialogTitle>
                <DialogContent>
                    <Box pt={2}>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <TextField
                                    value={item.code}
                                    name="code"
                                    size="small"
                                    label="Код"
                                    placeholder="Например: SAL, LH, AA"
                                    fullWidth
                                    onChange={this.changeItem}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    value={item.meaning}
                                    name="meaning"
                                    size="small"
                                    label="Расшифровка"
                                    placeholder="Например: Land Rover"
                                    fullWidth
                                    multiline
                                    minRows={2}
                                    maxRows={8}
                                    onChange={this.changeItem}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    value={item.year_from}
                                    name="year_from"
                                    size="small"
                                    label="Год от (необязательно)"
                                    type="number"
                                    fullWidth
                                    onChange={this.changeItem}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    value={item.year_to}
                                    name="year_to"
                                    size="small"
                                    label="Год до (необязательно)"
                                    type="number"
                                    fullWidth
                                    onChange={this.changeItem}
                                />
                            </Grid>
                        </Grid>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Grid justifyContent="flex-end" container px={2} spacing={1}>
                        <Grid item>
                            <Button size="small" variant="outlined" onClick={this.close}>Закрыть</Button>
                        </Grid>
                        <Grid item>
                            <Button
                                size="small"
                                variant="contained"
                                disabled={!item.code || !item.meaning}
                                onClick={this.submitItem}
                            >Сохранить</Button>
                        </Grid>
                    </Grid>
                </DialogActions>
            </Dialog>
        );
    }
}

DialogItemForm = withStyles(dialogTitleStyles)(DialogItemForm);

export default DialogItemForm;
